import {  makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    minHeight: '95vh'
  },
  subtitle: {
    color: theme.palette.primary.main,
    fontSize: 24,
    fontWeight: 300,
  },
  insuranceContainer: {
    marginTop: theme.spacing(2),
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
}));

